<template>
  <span class="label-new">
    <icon-check-mark/>
    <label class="ml-4 label-new__name">Новая</label>
  </span>
</template>
<script>
import IconCheckMark from '../../icons/icon-check-mark'
export default {
  name: 'LabelNew',
  components: {
    IconCheckMark
  }
}
</script>
